import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';

import type { PopupListItem } from 'webapp-types';

import CommonUiIcon from 'webapp/components/common/ui-icon';

interface CommonPopupsMultiListListComponentInterface {
	Args: {
		items: PopupListItem<string>[];
		doAction: (actionName?: string, ...args: unknown[]) => void;
		skipLine: boolean;
	};
}

const PopupsMultiListListComponent: TOC<CommonPopupsMultiListListComponentInterface> = <template>
	{{#unless @skipLine}}
		<hr />
	{{/unless}}

	<ul class="links context-ct">
		{{#each @items as |item|}}
			<li class={{item.class}}>
				<a role="button" {{on "click" (fn @doAction item.action item.id)}}>
					{{#if item.icon}}
						<CommonUiIcon @name={{item.icon}} @size="sm" @fill={{item.color}} />
					{{/if}}
					{{item.text}}
				</a>
			</li>
		{{/each}}
	</ul>
</template>;

export default PopupsMultiListListComponent;
